import { Pipe, PipeTransform } from "@angular/core";
import { getRiskEvaluationStatusLabel } from "@/_models/risk-evaluation.model";

@Pipe({
    name: "riskEvaluationStatusLabel",
    standalone: true,
})
export class RiskEvaluationStatusLabelPipe implements PipeTransform {
    transform(status: string | null | undefined): string {
        return getRiskEvaluationStatusLabel(status);
    }
}
